import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useLocation, useHistory } from 'react-router-dom';
import * as classnames from 'classnames';

import SearchForm from '../SearchForm';
import User from '../User';
import Card from '../Card';
import Document from '../Document';
import SearchFormFilter from '../SearchFormFilter';
import { getAlgoliaSearchHcProviderData, getPatientsHcProvider } from '../../app/actions/appActions';
import { setLightFooter } from '../../app/actions/uiActions';

import './styles.scss';

const SearchResult = () => {
	const location = useLocation()
	const history = useHistory()
	const dispatch = useDispatch();
	const algoliaData = useSelector((state) => state.app.algoliaData);
	const auth = useSelector((state) => state.firebase.auth);
	const [maxContent, setMaxContent] = useState(false)
	const [searchData, setSearchData] = useState({});
	const [state, setState] = useState({
		virus: true,
		documents: true,
		patients: true
	});

	const handleSearchForm = (value) => {
		if(value) {
			dispatch(getAlgoliaSearchHcProviderData({value, hcProviderId: auth.uid}));
			history.push(`/search?q=${value}`);
		};
	};

	const handleChangeFilter = (target) => {
		setState((state) =>({...state,...target}));
		setMaxContent(true);
	};

	useEffect(() => {
		setSearchData(algoliaData);
	},[algoliaData]);

	useEffect(()=>{
		dispatch(getPatientsHcProvider(auth.uid));
		dispatch(setLightFooter(true));

		if(location.search) {
			const value = location.search.slice(3);
			handleSearchForm(value);
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	},[]); 

	return (
		<div className="serach-result serach-result--active">
			<div>
				<div className="serach-result__header">
					<SearchForm onChange={handleSearchForm} type='instantly'/>
				</div>
				<div className="serach-result__filter">
					<SearchFormFilter onChange={handleChangeFilter}/>
				</div>
				<div className="container">
					{Object.keys(searchData).map((el,i) => {

						if(el === 'virus' && state.virus && algoliaData.virus.length) {
							return (
								<div className="serach-result__item" key={i}>
									<h2 className="serach-result__item-title">
										{el}
									</h2>
									<div 
										className={classnames(`serach-result__content serach-result__content-${el}`,{
											"serach-result__content--active" : maxContent
										})}
									>
										{algoliaData[el].length ? (
											algoliaData[el].map((virus, i) => {
											return <Card virus={virus} isGreen key={i}/>
											}) 
										) : null
										}
									</div>
		
								</div>
							);
						};

						if(el === 'patients' && state.patients && algoliaData.patients.length) {
							return (
								<div className="serach-result__item" key={i}>
									<h2 className="serach-result__item-title">
										{el}
									</h2>
									<div 
										className={classnames(`serach-result__content serach-result__content-${el}`,{
											"serach-result__content--active" : maxContent
										})}
									>
										{algoliaData[el].length ? (
											algoliaData[el].map((patient, i) => ( 
												<Link to={`/patient/${patient.userId}`} key={i}>
													<User user={patient} withEmail isBig/>
												</Link>
											)) 
										) : null
										}
									</div>
		
								</div>
							);
						};

						if(el === 'documents' && state.documents && algoliaData.documents.length) {
							return (
								<div className="serach-result__item" key={i}>
									<h2 className="serach-result__item-title">
										{el}
									</h2>
									<div
										className={classnames(`serach-result__content serach-result__content-${el}`,{
											"serach-result__content--active" : maxContent
										})}
									>
										{algoliaData[el].length ? (
											algoliaData[el].map((document, i) => ( 
												<div className="serach-result__content-doc" key={i}>
													<Document document={document} key={i}/>
												</div> )) 
										) : null
										}
									</div>
		
								</div>
							);
						};

						return null;
					})}
				</div>
			</div>
		</div>
	);
};

export default SearchResult;
